import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ allowAdmin = true }) => {
  const { currentUser, isSuperAdmin } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  // If this is a regular user route (allowAdmin=false) and user is admin, redirect to admin area
  if (!allowAdmin && isSuperAdmin()) {
    return <Navigate to="/admin" replace />;
  }
  
  return <Outlet />;
};

export const AdminRoute = () => {
  const { currentUser, isSuperAdmin } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  if (!isSuperAdmin()) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <Outlet />;
};
